import { ComponentType } from 'react';
import { Route, useLocation, useParams } from 'react-router-dom';

import { RoutedDialogImplProps, SentryRoutes } from '..';


export type DialogRoutes = {
    [path: string]: ComponentType<RoutedDialogImplProps>;
};

interface RoutedDialogManagerProps {
    routes: DialogRoutes;
}

export function RoutedDialogManager({ routes }: RoutedDialogManagerProps) {
    const location = useLocation();
    const params = useParams();

    return (
        <SentryRoutes>
            {Object.entries(routes).map(([ path, DialogComponent ]) => (
                <Route
                    key={path}
                    path={`/${path}`}
                    element={(
                        <DialogComponent
                            closeTo={location.pathname.replace(`/${params['*']}`, '')}
                        />
                    )}
                />
            ))}
        </SentryRoutes>
    );
}
